import React from 'react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full mt-4 sm:mt-auto px-4">
      <div className="container mx-auto">
        <div className="px-6 py-6 bg-white shadow-shadow1 rounded-md">
          <p className="text-center text-jetgrey text-sm">
            GET ME THERE © {year}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
